import { render, staticRenderFns } from "./importTable.vue?vue&type=template&id=12369840&scoped=true"
import script from "./importTable.vue?vue&type=script&lang=js"
export * from "./importTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12369840",
  null
  
)

export default component.exports